goog.provide('el8.appchart.dialog.addRxSig');

goog.require('el8.template.appchart.dialog.addRxSig');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');


el8.appchart.dialog.addRxSig = (function() {
    var _spec = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Save New Custom Sig',
        modal: true,
        autoHeight: true,
        width: 400
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'save', 'Save', function() {
            var rxSig = el8.practicedata.rxSigs.create({});
            el8.practicedata.rxSigs.saveItem(rxSig.populate({
                name: _spec.name,
                directions: _spec.directions,
                sourceId: _spec.sourceId,
                sourceType: _spec.sourceType
            }));
            that.hide();
        }, true
    );
    buttonSet.addButton(
        'close', 'Dismiss', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);


    var super_show = that.show;
    that.show = function(spec) {
        _spec = spec;
        super_show.call(that);
        that.setContent(
            el8.template.appchart.dialog.addRxSig.content({
                name: spec.name,
                directions: spec.directions
            })
        );
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    return that;

})();

